// Script para rastrear produtos visitados em TODAS as páginas
// Adicione ao theme.liquid antes de </body>:
// <script src="{{ 'track-products.js' | asset_url }}" defer></script>

(function() {
  'use strict';
  
  // Detecta se estamos em página de produto
  const isProductPage = window.location.pathname.includes('/products/') && 
                       !window.location.pathname.includes('/cart');
  
  if (!isProductPage) return;
  
  // Função para salvar produto visitado
  const saveProductView = () => {
    try {
      // Extrai handle do URL
      const pathParts = window.location.pathname.split('/products/');
      if (pathParts.length < 2) return;
      
      const handle = pathParts[1].split('?')[0].split('/')[0];
      if (!handle) return;
      
      // Tenta pegar título do produto
      let title = '';
      const h1 = document.querySelector('h1');
      const productTitle = document.querySelector('.product__title, [class*="product-title"], h1.title');
      
      if (h1) {
        title = h1.textContent.trim();
      } else if (productTitle) {
        title = productTitle.textContent.trim();
      } else {
        title = document.title.split('|')[0].split('-')[0].trim();
      }
      
      // Cria objeto do produto
      const productInfo = {
        handle: handle,
        title: title,
        timestamp: new Date().getTime()
      };
      
      // Recupera lista atual
      let recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed') || '[]');
      
      // Remove se já existir (para mover para o topo)
      recentlyViewed = recentlyViewed.filter(p => p.handle !== productInfo.handle);
      
      // Adiciona no início
      recentlyViewed.unshift(productInfo);
      
      // Limita a 10 produtos
      recentlyViewed = recentlyViewed.slice(0, 10);
      
      // Salva no localStorage
      localStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed));
    } catch (error) {
      // Silencioso - não mostrar erros ao utilizador
    }
  };
  
  // Executa quando página carregar
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', saveProductView);
  } else {
    // Se já carregou, executa com delay
    setTimeout(saveProductView, 500);
  }
})();

